<template>
    <mds-label
        :on-dark="onDark"
        :size="size"
        :optional="optional"
        :optional-text="optionalText"
        :required="required"
        :required-text="requiredText"
        :text="label"
        :hidden-label="hiddenLabel"
        :for="selectId"
    >
        <slot name="mds-microcopy-above">
            <mds-microcopy v-if="microcopyAbove" :size="size" v-html="microcopyAbove" :on-dark="onDark" />
        </slot>
        <div :class="[$style['mds-select'], classObject, sizeClass]" :data-mds-version="version">
            <select
                v-bind="$attrs"
                v-on="inputListeners"
                :class="[$style['mds-select__input']]"
                :required="required"
                :aria-invalid="error"
                :id="selectId"
            >
                <option v-if="placeholder" disabled selected>{{ placeholder }}</option>
                <template v-for="(option, index) in options">
                    <optgroup v-if="option.children" :key="`option-${index}`" :label="option.text">
                        <option
                            v-for="optionChild in option.children"
                            :key="optionChild.text"
                            :value="optionChild.value"
                            :class="optionChild.class"
                            :disabled="optionChild.disabled"
                            >{{ optionChild.text }}</option
                        >
                    </optgroup>
                    <option
                        v-else
                        :key="`option-${index}`"
                        :value="option.value"
                        :class="option.class"
                        :disabled="option.disabled"
                        >{{ option.text }}</option
                    >
                </template>
                <slot></slot>
            </select>
            <span :class="[$style['mds-select__open-indicator']]">
                <mds-icon
                    :class="[$style['mds-select__open-icon']]"
                    name="caret-down"
                    title="caret-down"
                    size="small"
                />
            </span>
        </div>
        <div v-if="error" :class="$style['mds-select__field-error-wrapper']" aria-live="assertive">
            <mds-field-error
                v-for="(text, index) in errorText"
                :key="index"
                v-show="error"
                :size="size"
                v-html="text"
                :on-dark="onDark"
            />
        </div>
        <slot name="mds-microcopy-below">
            <mds-microcopy v-if="microcopyBelow" :size="size" v-html="microcopyBelow" :on-dark="onDark" />
        </slot>
    </mds-label>
</template>

<script>
    import MdsIcon from '@mds/icon';
    import MdsFieldError from '@mds/field-error';
    import MdsLabel from '@mds/label';
    import MdsMicrocopy from '@mds/microcopy';

    // Import component's API
    import MdsSelectProps from './select_props.js';

    export default {
        name: 'MdsSelect',
        inheritAttrs: false,
        components: {
            MdsIcon,
            MdsLabel,
            MdsFieldError,
            MdsMicrocopy,
        },
        props: MdsSelectProps,
        computed: {
            sizeClass() {
                return this.$style[`mds-select--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-select--error']] = this.error;
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
            inputListeners() {
                var vm = this;
                return Object.assign({}, this.$listeners, {
                    input(event) {
                        vm.$emit('input', event.target.value, event);
                    },
                });
            },
        },
        methods: {
            randomId() {
                const randomId = Math.random() * Math.floor(1000000);
                return `mds-select-${Math.round(randomId)}`;
            },
        },
        created() {
            this.selectId = this.$attrs.id ? this.$attrs.id : this.randomId();
        },
    };
</script>

<style lang="scss" module>
    @import './select.scss';
</style>
